// @flow

const getConfiguration = (props: any) => {
    return {
        enableToolbar: false,
        enableToolbarSearchField: false,
        enableHeader: false,
        enableItemSelection: false,
        enablePagination: false,
    };
}
export default getConfiguration;